import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ConditionDeveloperListComponent} from './developer-list/condition-developer-list.component';
import {ConditionDeveloperListResolve, ConditionDeveloperSummaryResolve} from './developer-list/condition-developer-list.resolve';
import {RouterModule} from '@angular/router';
import {MaterialInputModule} from '../../modules/@material-input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PaginatorModule} from '../../shared/housing-modules/modules';
import {ConditionListResolve} from './list/condition-list.resolve';
import {ConditionListComponent} from './list/condition-list.component';
import {ConditionComponent} from './condition.component';
import {ModalModule} from '../../modules/@modal';
import {ConditionLifecycleComponent} from './lifecycle/condition-lifecycle.component';
import {TabsModule} from '../../modules/@tabs/tabs.module';
import {SharedModule} from '../../shared/shared.module';
import {PopoverModule} from '../../modules/@popover/popober.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialInputModule,
    FormsModule,
    PaginatorModule,
    ReactiveFormsModule,
    ModalModule,
    TabsModule,
    SharedModule,
    PopoverModule,
  ],
  declarations: [
    ConditionDeveloperListComponent,
    ConditionListComponent,
    ConditionComponent,
    ConditionLifecycleComponent
  ],
  exports: [
    ConditionDeveloperListComponent,
    ConditionListComponent,
    ConditionComponent,
    ConditionLifecycleComponent
  ],
  providers: [
    ConditionDeveloperListResolve,
    ConditionDeveloperSummaryResolve,
    ConditionListResolve
  ]
})
export class ConditionModule { }
